<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :customRow="handleRow"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'type'">
          {{ Enum.noticeType.value[record.type] }}
        </template>
        <template v-else-if="column.key === 'status'">
          {{ Enum.noticeStatus.value[record.status] }}
        </template>
        <template v-else-if="column.key === 'departName'">
          {{ record.departList?.map(item => item.name)?.join(',') }}
        </template>
      </template>
    </a-table>

    <a-modal
        v-model:open="open"
        title="通知预览"
        :footer="null"
        :destroyOnClose="true"
        width="700px"
      >
        <add-notice
          :v-if="open"
          :isDetail="true"
          :isEdit="true"
          :editData="editData"
          :treeData="treeData"
        ></add-notice>
      </a-modal>
  </div>
</template>
<script setup>
  import { ref, reactive, onMounted, toRefs } from 'vue'
  import { getList, getDetail } from '@/api/notice/notice'
  import { getDept } from '@/api/system_manage/dept'
  import { buildTree } from '@/utils/tree'
  import { message } from 'ant-design-vue'
  import { useStore } from 'vuex'
  import AddNotice from '../notice/notice/action/addNotice.vue'
  import { getNoticeTypeEnum, getNoticeStatusEnum } from '@/api/notice/notice'
  const store = useStore()
  const Enum = toRefs(store.state.common)
  
  //2、表格
  const columns = [
    {
      title: '标题',
      dataIndex: 'title',
      key: 'title',
      align: 'left',
    },
    {
      title: '目标部门',
      dataIndex: 'departName',
      key: 'departName',
      align: 'left',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      align: 'left',
    },
    // {
    //   title: '状态',
    //   dataIndex: 'status',
    //   key: 'status',
    //   align: 'left',
    // },
    {
      title: '发布时间',
      dataIndex: 'publish_time',
      key: 'publish_time',
      align: 'left',
    },
  ]
  const dept = ref([])
  const tableData = ref([])
  const treeData = ref([])
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
  })
  const loading = ref(false)
  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }
  function fetch() {
    loading.value = true
    getList({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      status: 1,
    }).then(({ data }) => {
      pagination.value.total = data.total
      loading.value = false
      tableData.value = data.list?.map(item => {
        return {
          ...item,
          status: item.status.toString(),
        }
      })
    })
    getDept().then(({ data }) => {
      const tree = buildTree(data, { idName: 'depart_id' })
      dept.value = data
      treeData.value = tree
    })
  }
  onMounted(async () => {
    const typeEnum = await getNoticeTypeEnum()
    store.dispatch('common/setNoticeType', typeEnum.data, { saveData: true })
    const statusEnum = await getNoticeStatusEnum()
    store.dispatch('common/setNoticeStatus', statusEnum.data, { saveData: true })
    fetch()
  })

  //3、添加、编辑
  const open = ref(false)
  const editData = ref(null)
  
  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showDetailModal(record);
      }
    }
  }
  
  //6、详情
  async function showDetailModal(data) {
    const res = await getDetail({ noticeId: data.notice_id })
    if (res.data) {
      editData.value = res.data
      open.value = true
    } else {
      message.warn('获取预览失败' + res.message)
    }
  }
</script>
